import type { ComponentProps } from "react";

const DisconnectedWarningIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="32" cy="31.9961" r="31.5" fill="#FFE8D4" />
      <circle cx="31.9994" cy="31.996" r="27.8793" fill="#FFAB76" />
      <path
        d="M32.2169 36.4131C30.93 36.4131 29.88 35.3829 29.8554 34.0963L29.6241 21.9661C29.5965 20.5148 30.7653 19.3235 32.2169 19.3235C33.6684 19.3235 34.8373 20.5149 34.8096 21.9661L34.5783 34.0963C34.5537 35.383 33.5037 36.4131 32.2169 36.4131ZM32.2169 45.2114C31.4203 45.2114 30.7324 44.9338 30.1531 44.3787C29.5979 43.7993 29.3203 43.1114 29.3203 42.3149C29.3203 41.5183 29.5979 40.8425 30.1531 40.2873C30.7324 39.708 31.4203 39.4183 32.2169 39.4183C33.0134 39.4183 33.6893 39.708 34.2445 40.2873C34.8238 40.8425 35.1134 41.5183 35.1134 42.3149C35.1134 43.1114 34.8238 43.7993 34.2445 44.3787C33.6893 44.9338 33.0134 45.2114 32.2169 45.2114Z"
        fill="white"
      />
    </svg>
  );
};

export default DisconnectedWarningIcon;
